"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const intl_1 = require("@kyruus/intl");
const Banners_1 = require("../../../components/Banners");
const PhoneNumberLink_1 = __importDefault(require("../../../components/PhoneNumberLink/PhoneNumberLink"));
const messages_1 = __importDefault(require("../../lib/messages"));
function CancelationFailedBanner({ phone }) {
    const message = phone
        ? messages_1.default.apptCancelationFailed
        : messages_1.default.apptCancelationFailedNoProvider;
    return (react_1.default.createElement(Banners_1.WarningBanner, null,
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, message, { values: phone
                ? {
                    phone_number_link: react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone })
                }
                : undefined }))));
}
exports.default = CancelationFailedBanner;
CancelationFailedBanner.propTypes = {
    phone: prop_types_1.string.isRequired
};
//# sourceMappingURL=CancelationFailedBanner.js.map